import { render } from "./TagSpan2.vue?vue&type=template&id=5b2c53ce&scoped=true"
import script from "./TagSpan2.vue?vue&type=script&lang=js"
export * from "./TagSpan2.vue?vue&type=script&lang=js"

import "./TagSpan2.vue?vue&type=style&index=0&id=5b2c53ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2c53ce"]])

export default __exports__